import ApiClient from './ApiClient';

class ArtStylesClient extends ApiClient {
  constructor() {
    super('/art-styles/v1');
  }
}

const artStylesClient = new ArtStylesClient();

export default artStylesClient;
